import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Intro from "@/components/Intro";
import About from "@/components/About";
import Services from "@/components/Services";
import CallToAction from "@/components/CallToAction";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AnimatedBackground from "@/components/AnimatedBackground";
import ScrollToTopButton from "@/components/ScrollToTopButton";
import LocalBusinessSchema from "@/components/LocalBusinessSchema";
import SEO from "@/components/SEO";

const Index = () => {
  return (
    <main className="min-h-screen bg-background relative">
      <SEO
        title="22 Studios Nürnberg – Friseur, Facials & Nägel"
        description="Beautystudio in Nürnberg für Friseur, Facials, Nageldesign, Wimpernlifting & Laser-Haarentfernung. ★ 5.0 Google ★ Jetzt Termin buchen!"
        canonical="https://22studios.de/nuernberg"
      />
      <LocalBusinessSchema />
      <AnimatedBackground />
      <Navigation />
      <Hero />
      <Intro />
      <About />
      <Services />
      <CallToAction />
      <FAQ />
      <Contact />
      <Footer />
      <ScrollToTopButton />
    </main>
  );
};

export default Index;
